<script lang="ts">
	import { page } from '$app/stores';
	export let url: string;
	export let text: string;
	export let active: boolean | null = null;

	const fullUrl = $page.data?.location?.origin + url;
</script>

<li class="px-4 md:px-0 lg:min-w-0 lg:text-center" on:click on:keyup>
	<a
		href={fullUrl}
		on:click
		class="header-link relative my-6 block whitespace-nowrap text-lg leading-8 md:my-0 md:text-sm xl:text-lg"
		class:active={active || $page.url.href == fullUrl}>{text}</a
	>
</li>
